"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedstoneDataFeed = void 0;
var bluebird_1 = __importStar(require("bluebird"));
var fetchers_1 = require("./fetchers");
var data_package_utils_1 = require("./data-package-utils");
var DEFAULT_TIMEOUT_MILLISECONDS = 10000; // 10 seconds
var RedstoneDataFeed = /** @class */ (function () {
    function RedstoneDataFeed(dataFeedOptions) {
        if (dataFeedOptions === void 0) { dataFeedOptions = {}; }
        this.dataFeedOptions = dataFeedOptions;
        this.fetchers = [];
        // Init fetchers
        for (var _i = 0, _a = Object.entries(this.dataFeedOptions.dataSources.sources); _i < _a.length; _i++) {
            var _b = _a[_i], i = _b[0], source = _b[1];
            if (dataFeedOptions.asset && source.disabledForSinglePrices) {
                console.log("Skipping " + i + " (" + source.type + ") source init");
            }
            else {
                var fetcherForSource = fetchers_1.createFetcher(source, dataFeedOptions.asset);
                this.fetchers.push(fetcherForSource);
            }
        }
    }
    // This is the entrypoint function of this module
    RedstoneDataFeed.prototype.getSignedPrice = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var timeoutMilliseconds, useFirstValid, selectedResponse, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        timeoutMilliseconds = ((_a = this.dataFeedOptions.dataSources) === null || _a === void 0 ? void 0 : _a.timeoutMilliseconds)
                            || DEFAULT_TIMEOUT_MILLISECONDS;
                        useFirstValid = this.dataFeedOptions.dataSources.valueSelectionAlgorithm === "first-valid";
                        if (!useFirstValid) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchFirstValid(timeoutMilliseconds)];
                    case 1:
                        _b = _c.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.fetchAllAndSelectValid(timeoutMilliseconds)];
                    case 3:
                        _b = _c.sent();
                        _c.label = 4;
                    case 4:
                        selectedResponse = _b;
                        return [2 /*return*/, data_package_utils_1.convertResponseToPricePackage(selectedResponse)];
                }
            });
        });
    };
    RedstoneDataFeed.prototype.fetchFirstValid = function (timeoutMilliseconds) {
        return __awaiter(this, void 0, void 0, function () {
            var fetcherIndex, promises, err_1, additionalErrMsg_1, errIndex_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fetcherIndex = 0;
                        promises = this.fetchers.map(function (fetcher) {
                            fetcherIndex++;
                            return (function (fIndex) { return __awaiter(_this, void 0, void 0, function () {
                                var response, expectedSigner, isValid;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, fetcher.getLatestDataWithTimeout(timeoutMilliseconds)];
                                        case 1:
                                            response = _a.sent();
                                            expectedSigner = fetcher.getEvmSignerAddress();
                                            isValid = data_package_utils_1.validateDataPackage(response, this.dataFeedOptions, expectedSigner);
                                            if (isValid) {
                                                return [2 /*return*/, response];
                                            }
                                            else {
                                                console.warn("Invalid response for fetcher " + fIndex + "/" + this.fetchers.length + ": " + JSON.stringify(response));
                                                throw new Error("Received invalid response from fetcher: " + fIndex + "/" + this.fetchers.length);
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); })(fetcherIndex);
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, bluebird_1.default.Promise.any(promises)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1 instanceof bluebird_1.AggregateError) {
                            additionalErrMsg_1 = ' ', errIndex_1 = 0;
                            err_1.forEach(function (subError) {
                                additionalErrMsg_1 +=
                                    "\n| " + errIndex_1 + ": " + subError.message + ". Stack: " + subError.stack + " |\n";
                                errIndex_1++;
                            });
                            err_1.message += "Many errors: " + additionalErrMsg_1;
                        }
                        throw err_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RedstoneDataFeed.prototype.fetchAllAndSelectValid = function (timeoutMilliseconds) {
        return __awaiter(this, void 0, void 0, function () {
            var promises, results, validDataPackages, fetcherIndex, fetcher, fetcherResult, expectedSigner, dataPackage, isValid, selectedResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promises = this.fetchers.map(function (fetcher) {
                            return fetcher.getLatestDataWithTimeout(timeoutMilliseconds);
                        });
                        return [4 /*yield*/, Promise.allSettled(promises)];
                    case 1:
                        results = _a.sent();
                        validDataPackages = [];
                        for (fetcherIndex = 0; fetcherIndex < this.fetchers.length; fetcherIndex++) {
                            fetcher = this.fetchers[fetcherIndex];
                            fetcherResult = results[fetcherIndex];
                            expectedSigner = fetcher.getEvmSignerAddress();
                            if (fetcherResult.status === "fulfilled") {
                                dataPackage = fetcherResult.value;
                                isValid = data_package_utils_1.validateDataPackage(dataPackage, this.dataFeedOptions, expectedSigner);
                                if (isValid) {
                                    validDataPackages.push(dataPackage);
                                }
                            }
                        }
                        // Checking if there are any valid data packages
                        if (validDataPackages.length === 0) {
                            console.error(results);
                            throw new Error("Failed to load valid data packages");
                        }
                        selectedResponse = data_package_utils_1.selectDataPackage(validDataPackages, this.dataFeedOptions.dataSources.valueSelectionAlgorithm);
                        return [2 /*return*/, selectedResponse];
                }
            });
        });
    };
    return RedstoneDataFeed;
}());
exports.RedstoneDataFeed = RedstoneDataFeed;
//# sourceMappingURL=redstone-data-feed.js.map